package team.platforma.auth_data.network.body

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AuthBody(
    @SerialName("email") val email: String,
    @SerialName("password") val password: String
)
